// extracted by mini-css-extract-plugin
module.exports = {"diagnosticsWidgetRoot":"DiagnosticsWidget_diagnosticsWidgetRoot__99XlV"};